import { Injectable } from '@angular/core';
import { TypeAdresseTEMPOST } from '../../common/models/type.adresse.tempost';
import { TypeFacturation } from '../../common/models/type.facturation';

@Injectable({
  providedIn: 'root'
})
export class FacturationADService {

  constructor() { }

  getFacturation(controls){
    const typeFacturation: TypeFacturation = new TypeFacturation();
    typeFacturation.noServiceExecutant = controls.get('_SepSep_idAnnonceur_SepAtt_serviceexec')?.value;
    typeFacturation.libelle.denomination = controls.get('_SepSep_idAnnonceur_SepAtt_denomination')?.value;
    typeFacturation.libelle.cp = controls.get('_SepSep_idAnnonceur_SepAtt_codepostal')?.value;
    typeFacturation.libelle.pays = controls.get('_SepSep_idAnnonceur_SepAtt_pays')?.value;
    typeFacturation.libelle.siret = controls.get('_SepSep_idAnnonceur_SepAtt_siret')?.value;
    typeFacturation.numBonCommande = controls.get('_SepSep_idAnnonceur_SepAtt_engagementjuridique')?.value;
    typeFacturation.libelle.adr1 = controls.get('_SepSep_idAnnonceur_SepAtt_servicedestinataire')?.value;
    typeFacturation.libelle.adr2 = controls.get('_SepSep_idAnnonceur_SepAtt_immeublebatiment')?.value;
    typeFacturation.libelle.adr3 = controls.get('_SepSep_idAnnonceur_SepAtt_numerolibellevoie')?.value;
    typeFacturation.libelle.adr4 = controls.get('_SepSep_idAnnonceur_SepAtt_compladresseboitepostale')?.value;
    typeFacturation.libelle.tvaIntracommunautaire = controls.get('_SepSep_idAnnonceur_SepAtt_tvaIntracommunautaire')?.value;
    return typeFacturation;
  }
}
